'use strict';
/**
 * @author Maxim Seredkin
 * @param {$LogProvider} $logProvider
 */
export default ['$logProvider',
    function($logProvider) {
        $logProvider.debugEnabled(true);
    }];
